import jwtDefaultConfig from './jwtDefaultConfig';
import { $ctx } from '@themeConfig';
import router from '@/router';
import NProgress from 'nprogress';
import {fetchRetry} from './logError'
export default class JwtService {
  // Will be used by this service for making API calls
  axiosIns = null;
   rRequest = ''

  // jwtConfig <= Will be used by this service
  jwtConfig = { ...jwtDefaultConfig };

  // For Refreshing Token
  isAlreadyFetchingAccessToken = false;

  // For Refreshing Token
  subscribers = [];

  constructor(axiosIns, jwtOverrideConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = { ...this.jwtConfig, ...jwtOverrideConfig };
    // Request Interceptor
    this.axiosIns.interceptors.request.use(
      config => {
        // NProgress.start();
        // Get token from localStorage
        const accessToken = this.getToken();
        // If token is present add it to request's Authorization Header
        if (accessToken) {
          // eslint-disable-next-line no-param-reassign
          config.headers.apiKey = `${accessToken}`;
        }
        // else {
        //   localStorage.removeItem('userData');
        //   localStorage.removeItem('accessToken');
        //   localStorage.removeItem('area');
        //   router.push({ name: 'auth-login' }).catch((err) => {});
          this.rRequest = config
        // }
        return config;
      },
      error => Promise.reject(error)
    );

    // Add request/response interceptor
    this.axiosIns.interceptors.response.use(
      response => {
        // NProgress.done();
        fetchRetry(response, this.rRequest)
        if (response && response.status === 401) {
          if (
            localStorage.getItem('area') != null &&
            localStorage.getItem('area') == 'admin'
          ) {
            localStorage.removeItem('userData');
            localStorage.removeItem('accessToken');
            localStorage.removeItem('area');

            router.push({ name: 'auth-login' });
          } else {
            localStorage.removeItem('userData');
            localStorage.removeItem('accessToken');
            localStorage.removeItem('area');

            router.push({ name: 'auth-login' });

          }
          return '';
        }
        return response;
      },
      error => {
        // const { config, response: { status } } = error
        // NProgress.done();

        const { config, response } = error;
        // if (status === 401) {
          fetchRetry(response, this.rRequest)
          if (response && response.status === 401) {
            if (
              localStorage.getItem('area') != null &&
              localStorage.getItem('area') == 'admin'
            ) {
              localStorage.removeItem('userData');
              localStorage.removeItem('accessToken');
              localStorage.removeItem('area');
  
              router.push({ name: 'auth-login' });
            } else {
              localStorage.removeItem('userData');
              localStorage.removeItem('accessToken');
              localStorage.removeItem('area');
  
              router.push({ name: 'auth-login' });
  
            }
            return '';
          }
        if (response && response.status === 401) {
          if (
            localStorage.getItem('area') != null &&
            localStorage.getItem('area') == 'admin'
          ) {
            localStorage.removeItem('userData');
            localStorage.removeItem('accessToken');
            localStorage.removeItem('area');

            router.push({ name: 'auth-login' });
          } else {
            localStorage.removeItem('userData');
            localStorage.removeItem('accessToken');
            localStorage.removeItem('area');

            router.push({ name: 'auth-login' });
          }
        }

        return Promise.reject(error);
      }
    );
  }

  getToken() {
    return localStorage.getItem(this.jwtConfig.storageTokenKeyName);
  }

  setToken(value) {
    localStorage.setItem(this.jwtConfig.storageTokenKeyName, value);
  }

  login(...args) {
    return this.axiosIns.post(
      $ctx.API_URL + this.jwtConfig.loginEndpoint,
      ...args
    );
  }

  register(...args) {
    return this.axiosIns.post(
      $ctx.API_URL + this.jwtConfig.registerEndpoint,
      ...args
    );
  }
  post(url, ...args) {
    return this.axiosIns.post($ctx.API_URL + url, ...args);
  }
  get(url, ...args) {
    return this.axiosIns.get($ctx.API_URL + url, ...args);
  }
  put(url, ...args) {
    return this.axiosIns.put($ctx.API_URL + url, ...args);
  }
  delete(url, ...args) {
    return this.axiosIns.delete($ctx.API_URL + url, ...args);
  }
}
